<template>
    <ResponsiveGrid v-bind="{ rows, columns, gap }">
        <div v-for="metric of metrics" :key="metric.field">
            <slot v-bind="{ metric }">
                <h5 class="m-b-xs">
                    {{ metric.name }}
                </h5>
                <span class="text-2xl font-thin m-b-xs"
                    >{{ Number(metric.value).toLocaleString() }}
                </span>
            </slot>
        </div>
    </ResponsiveGrid>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import ResponsiveGrid from 'dashboard-js/components/ResponsiveGrid'

export default {
    components: { ResponsiveGrid },

    props: {
        model: {},
        rows: {},
        columns: {},
        gap: {},
    },

    data() {
        return {
            metricsConfig: [
                {
                    field: 'views_total',
                    name: 'Visninger',
                },
                {
                    field: 'views_unique',
                    name: 'Unikke visninger',
                },
                {
                    field: 'likes',
                    name: 'Likes',
                },
                {
                    field: 'comments',
                    name: 'Kommentarer',
                },
                {
                    field: 'contents_count',
                    name: 'Posts',
                },
            ],
        }
    },

    computed: {
        flexDirection() {
            return this.reversed ? 'flex-col-reverse' : 'flex-col'
        },
        metrics() {
            return this.metricsConfig
                .filter(metric => typeof this.model[metric.field] !== 'undefined')
                .map(metric => ({
                    ...metric,
                    value: this.model[metric.field] !== null ? this.model[metric.field] : 0,
                }))
        },
    },
}
</script>
